module.exports = __webpack_public_path__ + "static/media/rating-star-full.66901a21.svg";